const ALPHA_CODE_BY_COUNTRY: Record<string, string> = {
  'United States': 'us',
  Canada: 'ca',
};

/**
 * Country name to ISO 3166-1 alpha-2 code, for Google Places `componentRestrictions`.
 *
 * Unknown names fall back to `us`, matching legacy (`GoogleSearch.tsx`
 * `countryNametoAlphaCode`). A value that is already a 2-letter code passes through
 * lowercased, so a company configured with `CA` is not silently narrowed to the US.
 */
export function countryToAlphaCode(countryName: string): string {
  const trimmed = countryName.trim();
  const mapped = ALPHA_CODE_BY_COUNTRY[trimmed];
  if (mapped) return mapped;
  if (/^[a-z]{2}$/i.test(trimmed)) return trimmed.toLowerCase();
  return 'us';
}
